import React, { useContext, useState } from 'react'
import { Selected } from '../../../context/context'
import Colors from './Colors/Colors'
import Cantidades from './Cantidades/Cantidades'
import LogoSize from './LogoSize/LogoSize'
import LogoPosition from './LogoPosition/LogoPosition'
import Return from './Return'
import {
    CaracContainer,
    CaracInner,
    CaracImageContainer,
    CaracDetailsContainer,
    CaracImage,
    CaracImageInner,
} from './Elements'
import {
    imageMotion
} from './Motion'
import Presupuesto from '../Presupuesto/Presupuesto'
import { AnimatePresence } from 'framer-motion'

const Caracteristicas = () => {

    const [selected] = useContext(Selected)
    const [steps, setSteps] = useState(0)

    return(
        <CaracContainer>
            <CaracInner>
                <CaracImageContainer
                variants={imageMotion}
                initial="initial"
                animate="animate"
                exit="exit"
                >
                    <CaracImageInner>
                        <CaracImage src={selected.imagen}/>
                    </CaracImageInner>
                </CaracImageContainer>
                <CaracDetailsContainer>
                    <AnimatePresence exitBeforeEnter>
                        {
                            steps === 0 ?
                            <Colors 
                            colors={selected.coloresDisponibles}
                            setSteps={setSteps}
                            key="1"
                            /> 
                            :
                            steps === 1 ?
                            <Cantidades 
                            setSteps={setSteps}
                            key="2"
                            /> 
                            :
                            steps === 2 ? 
                            <LogoPosition 
                            setSteps={setSteps}
                            key="3"
                            />
                            :
                            steps === 3 ?
                            <LogoSize 
                            setSteps={setSteps}
                            key="4"
                            />
                            :
                            steps === 4 &&
                            <Presupuesto
                            key="5" />
                        }
                        {
                            steps >= 1 &&
                            <Return 
                            steps={steps} 
                            setSteps={setSteps} 
                            key="6"
                            />
                        }
                    </AnimatePresence>
                </CaracDetailsContainer>
            </CaracInner>
        </CaracContainer>
    )
}

export default Caracteristicas